export default "__VITE_ASSET__CUQUMs8A__"